import { render, staticRenderFns } from "./SelectSizeTemp.vue?vue&type=template&id=62c2906f&scoped=true"
import script from "./SelectSizeTemp.vue?vue&type=script&lang=js"
export * from "./SelectSizeTemp.vue?vue&type=script&lang=js"
import style0 from "./SelectSizeTemp.vue?vue&type=style&index=0&id=62c2906f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c2906f",
  null
  
)

export default component.exports